/* src/app/edge/live/energymonitor/chart/chart.component.scss */
.energymonitor-chart {
  text-align: center;
  margin-top: 0;
}
@media (min-width: 992px) {
  .energymonitor-chart {
    margin-top: 4rem;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .energymonitor-chart {
    margin-top: 2rem;
  }
}
/*# sourceMappingURL=chart.component.css.map */
